/** App routes for the unified behavioral patterns dashboard. */
export const BEHAVIORAL_PATTERNS_ROUTE = "/behavioral-patterns";
export const BEHAVIORAL_PATTERNS_TITLE = "Cognitive Behavioral Patterns";

/** Quick Clarity — home entry path. */
export const QUICK_CLARITY_ROUTE = "/";
export const QUICK_CLARITY_TITLE = "Quick Clarity";

/** Deep Reflection (EIER) — intentional structured CBT path; not on home. */
export const DEEP_REFLECTION_ROUTE = "/deep-reflection";
export const DEEP_REFLECTION_TITLE = "Deep Reflection";

/** Actions from Quick Clarity — Done / Not yet / Changed my mind. */
export const ACTIONS_ROUTE = "/actions";
export const ACTIONS_TITLE = "Actions";

/** @deprecated Use BEHAVIORAL_PATTERNS_ROUTE — redirects remain for old links. */
export const INTERPRETATION_PATTERNS_ROUTE = "/interpretation-patterns";
export const INTERPRETATION_PATTERNS_TITLE = "Interpretation patterns";

export function behavioralPatternsPath(segment) {
  if (!segment) return BEHAVIORAL_PATTERNS_ROUTE;
  return `${BEHAVIORAL_PATTERNS_ROUTE}/${segment.replace(/^\//, "")}`;
}
